import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Fuse from 'fuse.js';
import { data } from 'src/app/services/data/data-mock';

@Component({
  selector: 'app-simple-search',
  templateUrl: './simple-search.component.html',
  styleUrls: ['./simple-search.component.sass']
})
/**
 * TODO:
 * - Add support for resetting the textbox
 * - Add support for parent component to access textbox content (keyup event)
 */
export class SimpleSearchComponent implements OnInit {
  
  @Input('keys') _keys: string[]
  @Input('cyId') cyId: string = 'simple-search-text-input'
  @Input('placeholder') placeholder: string = this._t.instant('Search here...')

  @Output('res') result: EventEmitter<any[]> = new EventEmitter()
  
  @Input('data') set getData(val) {
    this._data = val
    this.initFuse()
  }

  _data: any[]
  searchText: string
  _searchRes: any[]

  _fuse: Fuse<any>

  constructor(
    private _t: TranslateService
  ) { }

  ngOnInit(): void {
    this.initFuse()
  }

  initFuse() {
    if (!this._data?.length) return

    const keysOpt = this._keys?.length ? { keys: this._keys } : null
    const finalOpt = {...keysOpt, threshold: 0.5 }
    this._fuse = new Fuse(this._data, finalOpt)

    this._searchRes = this._data
    this.result.emit(this._searchRes)
  }

  onSearchChange(evt: string) {
    this.searchText = evt.trim()

    if (!this._fuse) { console.error('onSearchChange().Fuse is not initialized'); return }

    if (evt) {
      const res = this._fuse.search(this.searchText)
      this._searchRes = res.map(ele => this._data[ele.refIndex])
    }
    else {
      this._searchRes = this._data
    }

    this.result.emit(this._searchRes)
  }

}
